import React from 'react';
import FinancialsWidgetBuilder from './FinancialsWidgetBuilder';
import FinancialsWidgetRenderer from './FinancialsWidgetRenderer';
import Preview from './Preview';
import type { WidgetDefinition } from '../../../registry';
import type { FinancialsWidgetConfig } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons';

export { default as FinancialsWidgetRenderer } from './FinancialsWidgetRenderer';
export * from './types';

export const definition: WidgetDefinition = {
  type: 'financials',
  meta: {
    label: 'Financial Statements',
    icon: React.createElement(FontAwesomeIcon, { icon: faFileInvoiceDollar }),
    description: 'Annual revenue, profit, and net margin trend from point-in-time fundamentals',
    isSystem: true,
    isCreatable: true,
    requiresAsset: true,
    dataFlow: 'display',
  },
  dataProvider: {
    widget: 'FINANCIALS',
  },
  defaultSize: { w: 6, h: 5, minW: 4, minH: 4 },
  defaultConfig: () => ({} as FinancialsWidgetConfig),
  Builder: FinancialsWidgetBuilder,
  Renderer: FinancialsWidgetRenderer,
  Preview,
};
